import { getLocale } from "../runtime";

const da_searchbarplaceholder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `F.eks. 'økologisk makeup'`
};

const en_searchbarplaceholder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `E.g. 'organic makeup'`
};

const es_searchbarplaceholder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `P.ej. 'maquillaje ecológico'`
};

const fi_searchbarplaceholder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Esim. 'luomu meikki'`
};

const nb_searchbarplaceholder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `F.eks. 'økologisk sminke'`
};

const sv_searchbarplaceholder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `T.ex. 'ekologisk makeup'`
};

const searchbarplaceholder = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_searchbarplaceholder(inputs)
	if (locale === "en") return en_searchbarplaceholder(inputs)
	if (locale === "es") return es_searchbarplaceholder(inputs)
	if (locale === "fi") return fi_searchbarplaceholder(inputs)
	if (locale === "nb") return nb_searchbarplaceholder(inputs)
	if (locale === "sv") return sv_searchbarplaceholder(inputs)
	return "searchBarPlaceholder";
};

export { searchbarplaceholder as "searchBarPlaceholder" };